import { Stack } from '@fluentui/react';
import React from 'react';
import Footer from '../Footer';
import Header from '../Header';
import Content from './Content';

const LayoutOffline = () => {

    return <Stack verticalFill>
        <Header />
        <Content />
        <Footer />
    </Stack>;

};

export default LayoutOffline;